import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'DELETE_CUSTOMER_CATEGORY';

export async function deleteSeniority(
    userToken: string,
    seniorityId: number
) {
    try {
        const response = await axios.delete(
            `${URL}/seniorities/${seniorityId}/`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de la suppression d\'un DAS',
            error: error
        });
    }
}
